export default {
  default: {
    label: 'Apply as default',
    placeholder: '',
    system: {
      name: 'is_default',
    },
    value: false,
    errors: [],
    type: 'checkbox',
    name: 'default',
    rules: {
      title: '',
      required: false,
    }
  },
  label: {
    label: 'Label',
    placeholder: 'Add label',
    system: {
      name: 'label',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'label',
    rules: {
      title: 'Label field',
      required: true,
    }
  },
};



// WEBPACK FOOTER //
// ./src/containers/JobCardsEdit/fields.js